@if(notification()){
<div @toast #NotificationContainer class="cb-toast">
    <cb-notification [key]="notification()!.key" [showCloseButton]="true" [color]="notification()!.color"
        [hierarchy]="notification()!.hierarchy" [title]="notification()!.title" [message]="notification()!.message"
        [icon]="notification()!.icon ?? ''" [actions]="notification()!.actions ?? []"
        [image]="notification()!.image ?? ''" [imageStyle]="notification()!.imageStyle ?? 'thumbnail'"
        (actionClicked)="onActionClicked($event)" (closeClicked)="close()"></cb-notification>
</div>
}